"use client";

import { useParams } from "next/navigation";
import { useState } from "react";
import { ResponsiveModal } from "@/components/responsive-modal";
import { PasteTextForm } from "@/features/files/components/paste-text-form";
import { YouTubeUrlForm } from "@/features/files/components/youtube-url-form";
import { useI18n } from "@/locales/client";
import useImportFileModal from "../hooks/use-import-modal";
import { AnkiImportDropzone } from "./anki-import-dropzone";
import { UploadDropZone } from "./upload-dropzone";

const UploadFileModal = () => {
  const { isOpen, onClose, method } = useImportFileModal();
  const params = useParams<{ studySetId?: string }>();
  const studySetId = params.studySetId;
  const t = useI18n();
  const [filePhase, setFilePhase] = useState<"upload" | "select_sections">(
    "upload",
  );

  const title =
    method === "file_upload" && filePhase === "upload"
      ? t("newStudySetDrawer.steps.uploadContent.title")
      : method === "file_upload" && filePhase === "select_sections"
        ? t("tableOfContentsForm.selectSections")
        : method === "paste_text"
          ? t("newStudySetDrawer.steps.uploadContent.title")
          : method === "youtube_url"
            ? t("newStudySetDrawer.steps.uploadContent.title")
            : method === "anki_import"
              ? t("newStudySetDrawer.steps.uploadContent.ankiTitle")
              : "";

  const description =
    method === "file_upload" && filePhase === "upload"
      ? t("newStudySetDrawer.steps.uploadContent.description")
      : method === "file_upload" && filePhase === "select_sections"
        ? t("tableOfContentsForm.selectSectionsDescription")
        : method === "paste_text"
          ? t("newStudySetDrawer.steps.uploadContent.description")
          : method === "youtube_url"
            ? t("newStudySetDrawer.steps.uploadContent.description")
            : method === "anki_import"
              ? t("newStudySetDrawer.steps.uploadContent.ankiDescription")
              : "";

  const form =
    method === "file_upload" ? (
      <UploadDropZone
        id={studySetId}
        onClose={onClose}
        className="h-52"
        onPhaseChange={(p) => setFilePhase(p)}
      />
    ) : method === "paste_text" ? (
      <PasteTextForm
        id={studySetId}
        handleComplete={onClose}
        cancel={onClose}
        cancelText={t("cancel")}
      />
    ) : method === "anki_import" ? (
      <AnkiImportDropzone id={studySetId} onClose={onClose} className="h-52" />
    ) : (
      <YouTubeUrlForm
        id={studySetId}
        handleComplete={onClose}
        cancel={onClose}
        cancelText={t("cancel")}
      />
    );

  return (
    <ResponsiveModal
      title={title}
      description={description}
      open={isOpen}
      onOpenChange={onClose}
      form={form}
    />
  );
};
export default UploadFileModal;
